import React from "react";
import ReactDOM from "react-dom/client";
import { StyledEngineProvider } from "@mui/material/styles";
import reportWebVitals from "./reportWebVitals";
import "./assets/style/index.css";
import "./assets/style/animations.css";
import App from "./components/App";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <StyledEngineProvider injectFirst>
      <App />
    </StyledEngineProvider>
  </React.StrictMode>
);

//  Analytics: reportWebVitals(console.log); Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
